import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";

const OrderByHeaders = ({ orderingRef, styleHeaders = {} }) => {
    const [params, setParams] = useState([]);

    useEffect(() => {
        if (orderingRef.current.headers.length > 0) {
            setParams([...orderingRef.current.headers]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderingRef.current.headers]);

    const removeSort = (attr) => {
        orderingRef.current.removeSort(attr);
        setParams([...orderingRef.current.headers]);
    };

    const handleSort = (attr) => {
        const header = orderingRef.current.headers.find((h) => h.attr === attr);
        if (!header || header.disabled) return;
        orderingRef.current.handleSort(attr);
        setParams([...orderingRef.current.headers]);
    };

    return params.length
        ? params.map((param, idx) => (
            <th
                key={idx}
                style={"style" in param ? { ...styleHeaders, ...param.style } : styleHeaders}
                className="border-bottom-sticky">
                <div className="order-by-container">
                    <div className="order-by-container-label">
                        <span
                            onClick={() => !param.disabled && handleSort(param.attr)}
                            className={param.disabled ? "order-by-label disabled" : "order-by-label"}
                            style={param.disabled ? { cursor: "default" } : {}}>
                            {param.name}
                        </span>
                        {param.active && (
                            <span className="order-by-icon">
                                {param.direction === "asc" ? (
                                    <FontAwesomeIcon icon="caret-up" className="text-secondary" />
                                ) : (
                                    <FontAwesomeIcon icon="caret-down" className="text-secondary" />
                                )}
                            </span>
                        )}
                        {/* Agregar lo siguiente para ocultar la x si no está solo el campo default: !orderingRef.current.isOnlyDefaultActive() && */}
                        {param.active && !param.disabled && (
                            <button
                                className="btn btn-link text-secondary order-by-button"
                                type="button"
                                onClick={() => removeSort(param.attr)}>
                                <FontAwesomeIcon icon="xmark" />
                            </button>
                        )}
                    </div>
                </div>
            </th>
        ))
        : "";
};
export default OrderByHeaders;
